// tienda/ModalidadesSection.jsx

import React from "react";
import { motion } from "framer-motion";
import { Package, Store } from "lucide-react";
import { brand, fadeUp } from "../shared/brand";
import { TierCard } from "./TierCard";

export function ModalidadesSection() {
  return (
    <section className="border-b bg-white" style={{ borderColor: brand.line }}>
      <div className="mx-auto max-w-7xl px-4 py-14 md:py-20">
        <motion.div {...fadeUp} className="mb-9 flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="mb-3 text-xs font-black uppercase tracking-[0.2em]" style={{ color: brand.primary }}>
              Modalidades
            </p>
            <h2 className="max-w-2xl text-3xl font-black md:text-4xl" style={{ color: brand.ink }}>
              Opera desde tu tienda o desde fulfillment Fast Max.
            </h2>
          </div>
          <p className="max-w-sm text-sm leading-relaxed" style={{ color: brand.muted }}>
            Primero define desde dónde sale el producto. Luego eliges el nivel de servicio:
            Clásico, Coordinado o Premium según el riesgo y prioridad del pedido.
          </p>
        </motion.div>

        <div className="grid gap-4 md:grid-cols-2">
          <TierCard
            icon={<Store className="size-5" />}
            tag="Recojo en tienda"
            tagColor={brand.accentGold}
            title="Despachamos desde tu local"
            price="S/ 9.90"
            priceSuffix="desde Clásico"
            cutoff="Recojo hasta 12:00 PM"
            delivery="Entregas same-day hasta 2:00 PM o hasta llegada del driver al recojo"
            perks={[
              "Registra pedidos desde la plataforma",
              "Puedes completar entregas del recojo hasta que el driver llegue a tu tienda",
              "Elige Clásico para entrega estándar, Coordinado para mayor éxito operativo o Premium para prioridad",
              "Seguimiento operativo para tu tienda y tu cliente final",
              "COD y conciliación visible cuando aplique",
            ]}
          />
          <TierCard
            icon={<Package className="size-5" />}
            tag="Fulfillment FM"
            tagColor={brand.accentGreen}
            title="Tu stock en nuestro almacén"
            price="S/ 14.90"
            priceSuffix="Coordinado recomendado"
            cutoff="Same-day hasta 2:00 PM"
            delivery="Inventario, packing, preparación y despacho desde Fast Max"
            featured
            perks={[
              "Envía tu stock a nuestro almacén",
              "Procesamos, empacamos y despachamos tus pedidos desde Fast Max",
              "Inventario activo gratuito y visible desde la pestaña de inventario",
              "Ideal para Coordinado: COD completo, tracking y experiencia para cliente final",
              "Premium puede priorizar pedidos urgentes dentro de la ruta",
            ]}
          />
        </div>
      </div>
    </section>
  );
}
